import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import Helmet from "react-helmet"
import favicon from "../images/favicon.png"
import logoSVG from "../images/logo.svg"
import inverseLogoSVG from "../images/MissionLabs_Logo_Stacked_Strapline.svg"
import TwitterLogo from "../images/Twitter (1).svg"
import LinkedInLogo from "../images/Group 87 (1).svg"
import BurgerSVG from "../images/menu.svg"
import ExitSVG from "../images/close_menu.svg"
import Solutions from "./solutions"
import Modal from "./modal"
import ContactForm from "../pages/contact-us"
import "./header.scss"

import menuCloud from "../images/menu/menu_cloud.svg"
import menuContact from "../images/menu/menu_contact.svg"
import menuAutomation from "../images/menu/menu_automation.svg"
import menuEfficiency from "../images/menu/menu_effeciency.svg"
import menuConnect from "../images/menu/menu-connect.svg"
import menuQuality from "../images/menu/menu_quality.svg"
import menuPayments from "../images/menu/menu_payments.svg"

const menuTypes = {
  solutions: "solutions",
  products: "products",
}

const Header = props => {
  const [navOpen, setNav] = useState(false)
  const [selectedNavSection, setSelectedNavSection] = useState(null)
  const [isMobile, setIsMobile] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const solutionsMenu = [
    {
      navItem: "Cloud Communications",
      icon: menuCloud,
      linksTo: "/solutions/cloud-communication",
    },
    {
      navItem: "Contact Centre",
      icon: menuContact,
      linksTo: "/solutions/contact-centre",
    },
    {
      navItem: "Contact Automation",
      icon: menuAutomation,
      linksTo: "/solutions/contact-automation",
    },
    {
      navItem: "Agent Efficiency",
      icon: menuEfficiency,
      linksTo: "/solutions/agent-efficiency",
    },
    {
      navItem: "Amazon Connect",
      icon: menuConnect,
      linksTo: "/solutions/amazon-connect",
    },
    {
      navItem: "Quality Management",
      icon: menuQuality,
      linksTo: "/solutions/quality-management",
    },
    {
      navItem: "Payments & PCI",
      icon: menuPayments,
      linksTo: "/solutions/payments-pci",
    },
  ]

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1140px)")
    setIsMobile(mq.matches)

    const matchMediaListner = () => {
      setIsMobile(mq.matches)
    }

    mq.addListener(matchMediaListner)

    return function cleanUp() {
      mq.removeListener(matchMediaListner)
    }
  }, [])

  const clickHandler = menuTitle => {
    if (menuTitle === selectedNavSection) {
      setNav(false)
      setSelectedNavSection(null)
    } else {
      setSelectedNavSection(menuTitle)
      setNav(true)
    }
  }

  const mobileClickHandler = () => {
    setNav(!navOpen)
    setSelectedNavSection(null)
  }

  const mobileSubMenuClickHandler = menuTitle => {
    if (menuTitle === selectedNavSection) {
      setSelectedNavSection(null)
    } else {
      setSelectedNavSection(menuTitle)
    }
  }

  const displayModal = e => {
    setShowModal(!showModal)
  }

  const showHideModalOnClickOutSide = e => {
    if (e.target && e.target.className === "modal-backdrop") {
      setShowModal(!showModal)
    }
  }

  //   React.useEffect(() => {
  //     const handleClick = (e) => {
  //       if (e.target && e.target.className === "modal") {
  //         return setIsShown(false);
  //       }
  //     };
  //     if (isShown) {
  //       window.addEventListener("click", handleClick);
  //     }
  //   }, [isShown]);

  //   return (
  //     <React.Fragment>
  //       {toggle(show)}
  //       {isShown && content(hide)}
  //     </React.Fragment>
  //   );
  // };

  const renderDropdown = () => {
    switch (selectedNavSection) {
      case menuTypes.solutions:
        return <Solutions solutionsMenuItems={solutionsMenu} />
        break
      default:
        break
    }
  }

  const renderMobileDropdown = () => {
    return (
      <section className="mobile-nav-dropdown inverse">
        <div>
          <div
            className={
              selectedNavSection === menuTypes.solutions
                ? " bold active"
                : "bold"
            }
            onClick={() => mobileSubMenuClickHandler(menuTypes.solutions)}
          >
            Solutions.
          </div>
          <hr />
          {selectedNavSection === menuTypes.solutions && (
            <div className="mobile-nav-dropdown__subMenu">
              <Link to="/solutions/cloud-communication">
                Cloud Communications
              </Link>
              <hr />
              <Link to="/solutions/contact-centre">Contact Centre</Link>
              <hr />
              <Link to="/solutions/contact-automation">Contact Automation</Link>
              <hr />
              <Link to="/solutions/agent-efficiency">Agent Efficiency</Link>
              <hr />
              <Link to="/solutions/amazon-connect">Amazon Connect</Link>
              <hr />
              <Link to="/solutions/quality-management">Quality Management</Link>
              <hr />
              <Link to="/solutions/payments-pci">Payments & PCI</Link>
            </div>
          )}

          <Link className="bold" to="/technology" activeClassName="active">
            Technology.
          </Link>

          <hr />

          <Link className="bold" to="/products">
            Products.
          </Link>

          <hr />

          <Link className="bold" to="/integrations">
            Integrations.
          </Link>

          <hr />

          <Link className="bold" to="/clients">
            Clients.
          </Link>

          <hr />

          <Link className="bold" to="/about">
            About Us.
          </Link>

          <hr />

          <Link className="bold" to="/blog">
            Blog.
          </Link>

          <hr />
        </div>
        <div className="mobile-nav-dropdown__footer">
          <div className="button" onClick={displayModal}>
            Get In Touch
          </div>
          <Modal
            show={showModal}
            showHideModal={displayModal}
            showHideModalOnClickOutSide={showHideModalOnClickOutSide}
          >
            <ContactForm
              hubSpotForm={props.hubSpotForm}
              showHideModal={displayModal}
            />
          </Modal>
          <a
            href="https://www.linkedin.com/company/missionlabs"
            target="_blank"
            rel="noreferrer"
          >
            <img src={LinkedInLogo} alt="" />
          </a>
          {/* <img src={FacebookLogo} /> */}
          <a
            href="https://twitter.com/MissionLabsHQ"
            target="_blank"
            rel="noreferrer"
          >
            <img src={TwitterLogo} alt="" />
          </a>
          {/* <img src={InstagramLogo} /> */}
        </div>
      </section>
    )
  }

  return (
    <header>
      <Helmet>
        <link rel="icon" href={favicon} />
      </Helmet>
      <div className={navOpen && isMobile ? "header inverse" : "header"}>
        <div>
          <Link to="/">
            <img
              className="logo"
              src={navOpen && isMobile ? inverseLogoSVG : logoSVG}
              alt=""
            />
          </Link>
        </div>
        {isMobile != null && !isMobile && (
          <div className="nav">
            <div
              className={
                selectedNavSection === menuTypes.solutions
                  ? "nav__item active"
                  : "nav__item"
              }
              onClick={() => clickHandler(menuTypes.solutions)}
            >
              Solutions.
              {navOpen && (
                <>
                  {!isMobile && renderDropdown()}
                  <div
                    className="dropdown__overlay"
                    onClick={mobileClickHandler}
                  />
                </>
              )}
            </div>

            <Link
              className="nav__item"
              to="/technology"
              activeClassName="active"
            >
              Technology.
            </Link>

            <Link className="nav__item" to="/products" activeClassName="active">
              Products.
            </Link>

            <Link
              className="nav__item"
              to="/integrations"
              activeClassName="active"
            >
              Integrations.
            </Link>

            <Link className="nav__item" activeClassName="active" to="/clients">
              Clients.
            </Link>

            <Link className="nav__item" to="/about" activeClassName="active">
              About Us.
            </Link>

            <div className="button" onClick={displayModal}>
              Get In Touch
            </div>

            <Modal
              show={showModal}
              showHideModal={displayModal}
              showHideModalOnClickOutSide={showHideModalOnClickOutSide}
            >
              <ContactForm
                hubSpotForm={props.hubSpotForm}
                showHideModal={displayModal}
              />
            </Modal>
          </div>
        )}
        {isMobile && (
          <div className="mobile-nav" onClick={mobileClickHandler}>
            <img src={navOpen ? ExitSVG : BurgerSVG} alt="" />
          </div>
        )}
      </div>
      {navOpen && (
        <div className="dropdown">
          {isMobile && renderMobileDropdown()}
          <div className="dropdown__overlay" onClick={mobileClickHandler} />
        </div>
      )}
    </header>
  )
}

export default Header
